import {
  defineMessages,
  FormattedMessage as BaseFormattedMessage,
  FormattedMessageProps,
  FormattedNumber,
  IntlProvider,
  MessageDescriptor,
  RawIntlProvider,
  useIntl as baseUseIntl
} from "@react-intl";
import React from "react";

const DEFAULT_MESSAGE_ID = "default_message_id";

export const FormattedMessage = (props: FormattedMessageProps) => (
  <BaseFormattedMessage
    id={props.id || props.defaultMessage || DEFAULT_MESSAGE_ID}
    {...props}
  />
);

export const useIntl = () => {
  const intl = baseUseIntl();

  return {
    ...intl,
    FormattedMessage,
    formatMessage: (
      descriptor: MessageDescriptor,
      values?: Record<string, any>
    ) =>
      intl.formatMessage(
        {
          id: descriptor.id || descriptor.defaultMessage || DEFAULT_MESSAGE_ID,
          ...descriptor
        },
        values
      )
  };
};

export { IntlProvider, RawIntlProvider, FormattedNumber, defineMessages };
